import React from "react";
import { Headers, Header } from "@atlaskit/table-tree";

const LogHeader = ({ isGlobal }) => {
  let headerArray = [];
  if (isGlobal) {
    headerArray.push(
      <Header width="20%" key="integration">
        Integration
      </Header>
    );
  }
  headerArray.push(
    <Header width={200} key="action">
      Action
    </Header>
  );
  headerArray.push(
    <Header width={200} key="date">
      Date
    </Header>
  );
  headerArray.push(
    <Header width={100} key="trigger">
      Trigger
    </Header>
  );
  headerArray.push(
    <Header width={100} key="context">
      Context
    </Header>
  );
  headerArray.push(
    <Header width={60} key="status">
      Status
    </Header>
  );
  headerArray.push(
    <Header width={80} key="time">
      Time
    </Header>
  );
  headerArray.push(
    <Header width={80} key="size">
      Size
    </Header>
  );
  return <Headers>{headerArray}</Headers>;
};
export default LogHeader;
